var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rj-tabs',{model:{value:(_vm.tabsActive),callback:function ($$v) {_vm.tabsActive=$$v},expression:"tabsActive"}},[_c('rj-tab-pane',{attrs:{"name":"1","label":"待审批申请单"}},[_c('WaitApproveList')],1),_c('rj-tab-pane',{attrs:{"name":"2","label":"已审批申请单"}},[_c('ApprovedList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }